

const configure = (config) => {
}

let user = null

const setUser = (userData) => {
  user = userData
}




const getUser = () => {
  return user
}

export {configure, setUser, getUser }